<template>
  <v-form ref="formRef" @submit.prevent="handleSubmit">
    <p class="fw-700">Data Diri</p>
    <div class="mb-3">
      <label for="" class="mb-3">NIK</label>
      <v-text-field
        placeholder="Nomor NIK"
        v-model="nik"
        dense
        filled
        solo
        class="input-primary"
        type="number"
        required
        :rules="[
          (value) => {
            return genericRequiredRule(value, 'Nomor NIK');
          },
          (value) => {
            return generic16DigitRule(value, 'Nomor NIK');
          },
        ]"
      ></v-text-field>
    </div>
    <div class="mb-3">
      <label for="" class="mb-3">Nomor Handphone</label>
      <v-text-field
        placeholder="Nomor Handphone"
        v-model="no_hp"
        dense
        filled
        solo
        class="input-primary"
        required
        :rules="[
          (value) => {
            return genericRequiredRule(value, 'Nomor Handphone');
          },
        ]"
      ></v-text-field>
    </div>
    <p class="fw-700">Data Dokumen</p>
    <div class="mb-3">
      <label for="" class="mb-3">Foto KTP</label>
      <v-file-input
        truncate-length="27"
        v-model="fileKTP"
        dense
        filled
        solo
        class="input-primary"
        accept="image/png, image/gif, image/jpeg"
        :rules="[
          (value) => {
            return genericRequiredRule(value, 'Foto KTP');
          },
        ]"
      ></v-file-input>
    </div>
    <div class="mb-3">
      <label for="" class="mb-3">Foto Kendaraan (optional)</label>
      <v-file-input
        truncate-length="27"
        v-model="fileFotoKendaraan"
        dense
        filled
        solo
        class="input-primary"
        accept="image/png, image/gif, image/jpeg"
      ></v-file-input>
    </div>
    <div class="mb-3">
      <label for="" class="mb-3">Foto KK</label>
      <v-file-input
        truncate-length="27"
        v-model="fileKK"
        dense
        filled
        solo
        class="input-primary"
        accept="image/png, image/gif, image/jpeg"
        :rules="[
          (value) => {
            return genericRequiredRule(value, 'Foto KK');
          },
        ]"
      ></v-file-input>
    </div>
    <div class="mb-3">
      <label for="" class="mb-3">Foto Bukti Jual Beli (optional)</label>
      <v-file-input
        truncate-length="27"
        v-model="fileBukti"
        dense
        filled
        solo
        class="input-primary"
        accept="image/png, image/gif, image/jpeg"
      ></v-file-input>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-md-5 col-lg-2 mb-3 mb-md-0">
        <v-btn @click="handleKembali" class="btn btn-kembali w-100">
          <box-icon name="arrow-back" color="#67747E" class="mr-2"></box-icon>
          Kembali
        </v-btn>
      </div>
      <div class="col-12 col-md-5 col-lg-2">
        <v-btn type="submit" class="btn btn-primary w-100">Lanjut</v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { FieldRequired } from "@/mixins/ValidationRules";

export default {
  name: "VerifikasiData",
  mixins: [FieldRequired],
  computed: {
    nik: {
      get() {
        return this.$store.state.main.form.nik;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "nik",
          value: value,
        });
      },
    },
    no_hp: {
      get() {
        return this.$store.state.main.form.no_hp;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "no_hp",
          value: value,
        });
      },
    },
    fileKTP: {
      get() {
        return this.$store.state.main.form.fileKTP;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "fileKTP",
          value: value,
        });
      },
    },
    fileFotoKendaraan: {
      get() {
        return this.$store.state.main.form.fileFotoKendaraan;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "fileFotoKendaraan",
          value: value,
        });
      },
    },
    fileKK: {
      get() {
        return this.$store.state.main.form.fileKK;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "fileKK",
          value: value,
        });
      },
    },
    fileBukti: {
      get() {
        return this.$store.state.main.form.fileBukti;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "fileBukti",
          value: value,
        });
      },
    },
  },
  methods: {
    handleKembali() {
      this.$store.commit("SET_STEPPER_ACTIVE", 1);
    },
    handleSubmit() {
      if (this.$refs.formRef.validate()) {
        this.$store.commit("SET_STEPPER_ACTIVE", 3);
      }
    },
  },
};
</script>
